import i18nData from '../../static-files/i18nConfig.json'
import localesMap from '../../static-files/localesMap.json'
import { LocaleData } from '@sentecacommerce-theme/lib'

export const getLocaleData = (locale?: string) => {
  return (localesMap[locale || ''] ||
    localesMap[i18nData.defaultLocale]) as LocaleData
}
